import React from "react";
import { Box, Link, Typography, Divider, Paper } from "@mui/material";
import CustomCard from "../../components/cards/CustomCard";
import RegisterStepper from "./RegisterStepper";

export const Register = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        maxWidth: "md", // Provides a clean, spacious landscape sheet for step forms
        p: { xs: 3, md: 4 },
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1)", // Core signature shadow
      }}
    >
      {/* Structural Registration Component Engine */}
      <RegisterStepper />

      {/* Account Verification Redirect Hyperlinks */}
      <Box sx={{ mt: 4, textAlign: "center" }}>
        <Typography
          sx={{
            fontSize: "15px",
            color: "#1C1E21",
            fontFamily: "SFProDisplay-Regular, Helvetica, Arial, sans-serif"
          }}
        >
          Already have an account?{" "}
          <Link
            href="/login"
            underline="hover"
            sx={{
              color: "#1877F2",
              fontWeight: "600",
              textDecoration: "none",
              "&:hover": { textDecoration: "underline" }
            }}
          >
            Log In
          </Link>
        </Typography>
      </Box>
    </Paper>
  );
};
